// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1lIde","paramInput":"JobSimulator_paramInput__-6URL","input":"JobSimulator_input__3A-Vl"};